<template>
  <el-dialog :title="$t('PAGE_CLIENTUSER_PAD_EMAIL')"
             visible
             width="55%"
             top="5vh"
             @close="onCancel">
    <div class="select-row">
      <el-form :inline="true" :model="emailForm" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="emailForm.userAccount" :placeholder="$t('COMMON_USER_ACCOUNT')" @keyup.enter.native="getTable" clearable class="select-item-cls input-with-select" />
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="emailForm.title" :placeholder="$t('TABLE_HEADER_title2')" @keyup.enter.native="getTable" clearable class="select-item-cls input-with-select" />
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="emailForm.userName" :placeholder="$t('COMMON_USER_NAME')" @keyup.enter.native="getTable" clearable class="select-item-cls input-with-select" />
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="emailForm.roleList" :placeholder="$t('TABLE_HEADER_Roles')" clearable filterable multiple collapse-tags class="select-item-cls2 input-with-select">
            <el-option
                    v-for="item in roleList"
                    :key="item.roleId"
                    :label="item.roleName"
                    :value="item.roleId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="emailForm.emailStatus" :placeholder="$t('EMAIL_SEND_STATUS')" clearable class="select-item-cls input-with-select">
            <el-option :label="$t('send_msg_success')" :value="true"></el-option>
            <el-option :label="$t('unsend_msg')" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" class="wl-green" @click="getTable">{{ $t('btn_search') }}</el-button>
          <el-button class="cancel-btn" @click="resetTable">{{ $t('COMMON_CLEAR_BTN') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table height="300px"
              v-loading="loading"
              :data="data"
              border
              @selection-change="handleSelectionChange"
              stripe>
      <el-table-column type="selection"
                       width="50">
      </el-table-column>
      <el-table-column prop="userAccount"
                       :label="$t('COMMON_USER_ACCOUNT')"
                       min-width="150">
      </el-table-column>
      <el-table-column prop="title" min-width="80"
                       :label="$t('TABLE_HEADER_title2')">
      </el-table-column>
      <el-table-column prop="userName" min-width="80"
                       :label="$t('COMMON_USER_NAME')">
      </el-table-column>
      <el-table-column prop="createDate"
                        min-width="80"
                       :label="$t('sendTime')">
        <template slot-scope="scope">
           <span v-if="scope.row.lastSendDateString">{{ scope.row.lastSendDateString | formatDateTime }}</span>
           <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column prop="emailStatus"
                       align="center"
                       width="100"
                       :label="$t('EMAIL_SEND_STATUS')">
        <template slot-scope="scope">
          <span v-if="scope.row.emailStatus" style="color: #67C23A">
            <i class="el-icon-success"></i>
            {{ $t('send_msg_success') }}
          </span>
          <span v-else style="color: #909399">
            <i class="el-icon-warning"></i>
            {{ $t('unsend_msg') }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="wl-pagination"
                   :current-page="pagination.pageNum"
                   :page-size="pagination.pageSize"
                   @size-change="onSizeChange"
                   @current-change="onCurrentPageChange"
                   :page-sizes="[10, 50, 100]"
                   layout="prev, pager, next, sizes, total"
                   :total="pagination.total">

    </el-pagination>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="cancel-btn">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 :loading="saveLoading"
                 @click="onConfirm"
                 class="wl-green">{{$t('comment_send')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
    import API from '@/api';
    import {mapGetters} from 'vuex';

    export default {
        data() {
            return {
                pagination: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                data: [],
                loading: false,
                emailForm: {
                  userAccount: null,
                  title: null,
                  userName: null,
                  roleList: [],
                  emailStatus: ''
                }
            };
        },
        methods: {
            handleSelectionChange(data) {
                this.selectList = data;
            },
            onSizeChange(value) {
              this.pagination.pageNum = 1
              this.pagination.pageSize = value
              this.getTable()
            },
            onCurrentPageChange(v) {
                this.pagination.pageNum = v
                this.getTable();
            },
            resetTable() {
              this.emailForm.userAccount = ''
              this.emailForm.title = ''
              this.emailForm.userName = ''
              this.emailForm.roleList = []
              this.emailForm.emailStatus = ''
              this.getTable()
            },
            getTable() {
                this.loading = true;
                this.emailForm.userAccount = this.emailForm.userAccount ? this.emailForm.userAccount.trim() : ''
                this.emailForm.title = this.emailForm.title ? this.emailForm.title.trim() : ''
                this.emailForm.userName = this.emailForm.userName ? this.emailForm.userName.trim() : ''
                const params = {
                    siteId: this.getSite.siteId,
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                    ...this.emailForm,
                };
                API.clientUser.notifyUser(params).then(res => {
                    if (res.code == '1') {
                        this.data = res.data.records;
                        this.pagination.total = res.data.total;
                        this.loading = false;
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                });
            },
            onConfirm() {
                if (this.selectList.length > 0) {
                    this.onAdd(this.selectList);
                }
            },
            roleListName(roles) {
                return _.map(roles, v => v.roleName).join('; ')
            }
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite'
            })
        },
        mounted() {
            this.getTable();
        },
        props: {
            onAdd: Function,
            onCancel: Function,
            saveLoading: Boolean,
            roleList: {
              type: Array,
              default: []
            }
        }
    };
</script>
<style scoped>
  .wl-m-select {
    width: 100%;
  }

  .wl-overflow-tooltip {
    overflow: hidden;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .select-item-cls{
    width: 130px;
  }
  .select-item-cls2{
    width: 150px;
  }
</style>
